import { render, staticRenderFns } from "./BrandDialog.vue?vue&type=template&id=4240bfb1"
import script from "./BrandDialog.vue?vue&type=script&lang=ts"
export * from "./BrandDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports